import React, {Component} from 'react';
import {Container} from 'react-bootstrap';
import Footer from '../common/Footer';
import Header from '../common/Header';

class CGU extends Component {

  render() {

    return (
      <>
        <Header currentAnchor={''} links/>
        <div className="document">
          <Container>
            <h1>CONDITIONS GENERALES D’UTILISATION<br/>APPLICATION MOBILE CLEAN BILL</h1>

            <h2>ARTICLE 1 – CHAMP D’APPLICATION</h2>

            <p>
              Les présentes Conditions d'utilisation constituent un contrat passé entre l’utilisateur, personne physique
              (le Client) et Clean Bill (le Fournisseur). Le présent document est un document important ; le Client doit
              l'étudier avec soin s’il envisage d'utiliser les Services de Clean Bill et ce, lors du téléchargement de
              l’Application et, le cas échéant, lors de toutes mises à jour. Le Fournisseur recommande de lire les
              termes du présent Contrat avec attention avant de les accepter sans réserve. Il appartient au Client de
              comprendre et de respecter toutes les lois, règles et réglementations françaises. La Politique de
              confidentialité Clean Bill, accessible sur le l’Application et le Site Internet Clean Bill (les Solutions
              Clean Bill), fait partie intégrante des présentes et comprend des conditions supplémentaires applicables à
              l'utilisation des Services.
            </p>

            <h3>Eligibilité</h3>
            <p>
              Pour être éligible aux Services Clean Bill, le Client doit avoir la pleine capacité légale pour conclure
              un contrat et avoir au moins 18 ans. A ce titre, le Client déclare et garantit à Clean Bill, lorsqu’il
              ouvre un Compte chez Clean Bill, qu’il n'agit pas au nom ou au profit de toute autre personne. Le présent
              Contrat s'applique uniquement aux Utilisateurs résidant en France.
            </p>

            <h3>Descriptif et accessibilité</h3>
            <p>
              L’application mobile Clean Bill (l’Application) permet de stocker et d’accéder aux reçus, factures, et
              bons d’achats ou de réduction, aux cartes de fidélités, bons de fidélités et tickets de carte bleue (le
              Reçu) de manière dématérialisée. Le service est accessible 24h sur 24, 7 jours sur 7 et toute l’année,
              sauf en cas d’opération de maintenance et sous réserve de problèmes de connexion Internet indépendants du
              Fournisseur. Les présentes Conditions Générales d’Utilisation sont accessibles à tout moment sur
              l’Application et prévaudront, le cas échéant, sur tout autre document contradictoire. Lors du
              téléchargement de l’Application et, afin de personnaliser l’environnement de chaque Client, un identifiant
              (adresse eMail et numéro de téléphone) doit être fourni par le Client et un mot de passe doit être choisi
              et saisi par le Client. En cas de perte de son mot de passe, le Client peut, en cliquant sur le lien « Mot
              de passe oublié » recevoir automatiquement par courriel son mot de passe. Ce mot de passe, strictement
              confidentiel, sera demandé au Client non authentifié avant chaque utilisation. Pour chaque opération, le
              Client devra se connecter en ouvrant l’Application et en rentrant son identifiant et son mot de passe dans
              l’espace dédié à cet effet. Le Fournisseur se réserve le droit, à tout moment, de modifier ou
              d’interrompre de manière temporaire tout ou partie de l’Application pour des raisons techniques ou autres
              et ce sans avoir à en informer préalablement le Client. Celui-ci ne peut engager la responsabilité du
              Fournisseur à raison des modifications et interruptions effectuées.
            </p>

            <h3>Champ d’application, opposabilité et durée des Conditions Générales d’utilisation</h3>
            <p>
              Le Client déclare avoir pris connaissance des présentes Conditions Générales d’Utilisation et les avoir
              acceptées intégralement et sans réserve en cochant la case prévue à cet effet avant le téléchargement
              complet de l’Application. Le Client reconnaît avoir pu négocier chacune des clauses du présent contrat,
              notamment en s’adressant au Fournisseur à l’adresse suivante : 39 b chemin de l’Usclade 30340 SAINT-
              PRIVAS-DES-VIEUX. Les présentes Conditions Générales d’Utilisation, lues intégralement et acceptées sans
              réserve, s’appliquent, sans restriction ni réserve, à l’ensemble des opérations réalisées via
              l’Application mobile par les Clients désirant stocker et consulter leurs Reçus. Ces Conditions Générales
              d’Utilisation pouvant faire l’objet de modifications ultérieures, la version applicable est celle en
              vigueur sur les Solutions Clean Bill à la date de téléchargement de l’application mobile par le Client ou
              bien à la date de chaque mise à jour, lors desquelles le Client peut être invité à souscrire à de
              nouvelles Conditions Générales d’Utilisation. Les Conditions Générales d’Utilisation sont valables pour la
              durée nécessaire à l’utilisation des services souscrits. Le fait que le Fournisseur ne se prévale pas à un
              moment donné d'une quelconque des clauses des Conditions Générales d’Utilisation ne peut être interprété
              comme valant renonciation à se prévaloir ultérieurement d'une quelconque desdites Clauses.
            </p>

            <h3>Preuve</h3>
            <p>
              Sauf preuve contraire apportée par le Client, les systèmes d'enregistrement automatique de l’Application
              mobile par le Fournisseur sont considérés comme valant preuve de la nature, du contenu et de la date du
              contrat.
            </p>

            <h3>Notifications sur les conditions générales d’Utilisation qui vous sont destinées</h3>
            <p>
              Le Client accepte que Clean Bill puisse lui adresser une notification ou toute autre information en la
              publiant sur l’Application Clean Bill ou en l’envoyant à l’adresse eMail ou postale du Client, par
              téléphone ou SMS. Le Client peut demander une copie de toutes les informations légales obligatoires (y
              compris le présent Contrat) et le Fournisseur la fournira sous une forme qui permet de conserver et de
              reproduire ces informations. Le Client peut également refuser de recevoir ces informations par voie
              électronique ou postale en contactant Clean Bill. Toute demande par voie postale peut engendrer la
              facturation des frais d’envoi.
            </p>

            <h3>Modification des Conditions Générales d’Utilisation</h3>
            <p>
              Le Fournisseur se réserve la possibilité d'adapter ou de modifier à tout moment les Conditions Générales
              d’Utilisation. En cas de modification, il sera appliqué les Conditions Générales d’Utilisation en vigueur
              au jour de l’utilisation de l’Application, toute mise à jour pouvant donner lieu à souscription de
              nouvelles Conditions Générales d’Utilisation. Aussi, le Client est invité à les consulter régulièrement
              afin de se tenir informé des évolutions les plus récentes.
            </p>

            <h2>ARTICLE 2 – CARACTERISTIQUES DU SERVICE</h2>

            <h3>Les prérequis</h3>
            <p>
              Le Client doit détenir un téléphone portable type smartphone (à partir de la version Androïd 7 ou IOS 11)
              et souscrire un abonnement Internet chez l’opérateur téléphonique de son choix et à ses frais, accessible
              depuis son mobile. Il doit télécharger l’Application Clean Bill, sur une plateforme quelconque de
              téléchargement sur laquelle Clean Bill est référencée. Le Client doit prendre connaissance intégralement
              et accepter sans réserve les présentes Conditions Générales d’Utilisation en cochant la case prévue à cet
              effet. Il doit créer un identifiant et un mot de passe personnels et confidentiels dont il aura seul
              l’entière responsabilité de conservation et de non-divulgation. Les informations demandées lors de la
              création du compte sont notamment le genre, le nom, le prénom, la date de naissance, le numéro de
              téléphone fixe ou mobile (à des fins d’identification uniquement), les adresses électronique et postale de
              résidence.
            </p>

            <h3>La création de reçus dématérialisés</h3>

            <p>
              Le Client doit présenter son identifiant (sous la forme d’un code barre personnel et unique ou son numéro
              de téléphone) aux Commerçants dotés de la technologie Clean Bill en ouvrant l’Application. Il peut accéder
              à la fiche du commerçant chez qui il effectue un achat et présenter sa carte de fidélité, ses éventuels
              bons de réduction et son code barre pour réception d’un nouveau Reçu. Le reçu relatif à l’achat effectué
              chez le Commerçant est alors accessible sur l’Application et classé par Enseigne. Les tickets de carte
              bleue sont à scanner directement par le Client via la fonction prévue à cet effet. Par ailleurs, le Client
              a la possibilité de scanner des tickets pré-imprimés en format papier et les insérer dans sa base de
              données via l’Application. La taille du téléchargement ne pourra dépasser 10 Mo par mois.
            </p>

            <h3>L’option Pro</h3>
            <p>
              Le Client peut souscrire à une option Pro qui permet l’identification, par un tag, des Reçus
              professionnels et de les classer entre eux, quelle que soit l’enseigne concernée. Cette option est payante
              et répond aux Conditions Générales de Vente auxquelles le Client souscrit en choisissant l’Option Pro. Les
              références de l’employeur ou de la société concernée seront alors demandées.
            </p>

            <h3>L’accessibilité aux reçus</h3>
            <p>
              Le Client accède à l’ensemble de ses reçus dématérialisés de moins d’un mois par simple consultation de
              l’Application. Les reçus dématérialisés de plus d’un mois sont consultables uniquement avec une connexion
              Internet du mobile. Dans ce second cas, le temps de téléchargement des reçus ne relève pas de la
              responsabilité du Fournisseur. Les Reçus sont conservés 5 ans, sauf souscription à l’Option Pro, payante,
              qui permet une conservation de 10 ans. Dans tous les cas, les Reçus restent la propriété du Client qui
              peut, en cas de défaillance du Fournisseur, s’adresser directement au Commerçant pour obtenir un
              justificatif d’achat.
            </p>

            <h3>Les notifications commerciales</h3>
            <p>
              Clean Bill propose de communiquer aux Clients qui manifestent leur accord, en cochant la case prévue à cet
              effet, les notifications commerciales des commerçants chez qui ils utilisent l’Application ou tout autres
              commerçants. À tout moment le Client peut se désinscrire de ce service de notifications commerciales.
              Aucune notification ne sera transmise par SMS ou eMail. Seul l’accès à l’Application ou au Site Internet,
              après identification, permettra d’en prendre connaissance.
            </p>

            <h3>Les échanges avec le commerçant</h3>
            <p>
              Le Client aura la possibilité d’échanger directement avec le commerçant inscrit sur son Application pour
              émettre toutes recommandations ou toutes réclamations relatives à l’émission de son Reçu. Aucun autre
              échange, notamment sur la garantie des produits ou services ayant fait l’objet de l’édition d’un reçu via
              l’Application Clean Bill ne pourra être réalisé via cette plateforme d’échanges. A ce titre, Clean Bill se
              dégage de toute responsabilité quant à la bonne transmission des messages et quant aux contenus des
              échanges. En cas de contenu inapproprié, le Client comme le commerçant peut signaler à Clean Bill les abus
              détectés.
            </p>

            <h3>Prix - paiement du prix</h3>
            <p>
              Le téléchargement et l’utilisation de l’Application est gratuite. Le Fournisseur peut toutefois proposer
              au Client des options payantes de gestion des reçus, notamment l’Option Pro. En cas de souscription à
              quelconque option payante, des conditions particulières de vente seront communiquées au Client. Il
              s’engagera alors à les lire et les accepter intégralement et sans réserve.
            </p>

            <h3>Contenu licite</h3>
            <p>
              Le Fournisseur rappelle que le Client ne pourra utiliser l’Application qu'à des fins légales et qu'il lui
              est interdit de publier ou de transmettre par l’Application tout élément illicite, préjudiciable,
              diffamatoire, pornographique, haineux, raciste ou autrement attentatoire à la dignité humaine. Au cas où
              le Fournisseur serait informé de la présence de contenus illicites sur l’Application, il serait en droit
              d'en supprimer immédiatement le contenu. Le Fournisseur se réserve par ailleurs la possibilité de prendre
              toutes les mesures nécessaires pour faire respecter ses droits. Le Fournisseur est en droit d'effectuer
              une surveillance électronique des documents téléchargés et des zones d’échanges entre le Client et le
              Commerçant pour vérifier leur conformité aux exigences ci-dessus. Il est également interdit de recueillir
              ou de stocker des informations personnelles autres que celles relatives aux Reçus. Le Fournisseur se
              réserve le droit de résilier le compte utilisateur en cas de non-respect des obligations susvisées. Toute
              utilisation de l’Application étrangère à celles visées au présent Contrat est strictement interdite.
            </p>

            <h2>ARTICLE 3 - RESPONSABILITES</h2>

            <h3>Du fait du mobile et de l’utilisation de l’Application</h3>
            <p>
              La responsabilité du fournisseur ne saurait être engagée en cas de détérioration ou de perte du téléphone
              mobile, que ce soit du fait du Client ou non. Aucune responsabilité du Fournisseur ne saurait être retenue
              si le service proposé par l’Application s'avère incompatible ou présente des dysfonctionnements avec
              certains logiciels, configurations, systèmes d'exploitation ou équipements utilisés par le Client. Il
              incombe au Client de protéger ses équipements techniques notamment contre toute forme de contamination par
              des virus et/ou de tentative d'intrusion et d’effectuer toutes sauvegardes de ses données. Le Client est
              seul responsable de l'utilisation qu’il peut faire des services proposés et ne saurait tenir responsable
              le Fournisseur pour toute réclamation et/ou procédure faite à son encontre. Par ailleurs, le Client
              s'engage à faire son affaire personnelle de toute réclamation et/ou procédure formée contre le Fournisseur
              et qui se rattacherait à son utilisation du service. Le Fournisseur se réserve le droit d'apporter à ses
              services toutes les modifications et améliorations qu'il jugera nécessaires ou utiles et ne sera pas
              responsable des dommages de toute nature pouvant survenir de ce fait. Les mises à jour de l’Application
              relèvent de la seule responsabilité du Client qui accepte de télécharger les nouvelles versions de
              l’Application. Par ailleurs, le fournisseur se réserve le droit, sans préavis ni indemnité, d'arrêter
              temporairement ou définitivement un service ou l'ensemble des services proposés. Il ne sera pas
              responsable des dommages de toute nature pouvant survenir de ce fait.
            </p>

            <h3>Du fait de la connexion Internet</h3>
            <p>
              Le Fournisseur sera également dégagé de toute responsabilité en cas de problème de connexion à Internet du
              Client ou d’accessibilité au réseau de connexion. A ce titre, le Client reconnaît que la connexion peut
              dépendre de son lieu de situation et qu’il persiste, en France et à l’étranger, des « zones blanches »
              dépourvues de connexion à Internet. Il s’engage à avoir un abonnement donnant accès en permanence à
              Internet.
            </p>

            <h3>Du fait de l’intégrité et de la conservation des données</h3>
            <p>
              La responsabilité de Clean Bill ne saurait être retenue en cas de perte ou corruption des données ou toute
              perte ou dommage qui ne résulte pas directement d’un manquement de sa part au présent contrat. Quant à la
              conservation des Données, la responsabilité du Fournisseur ne saurait être engagée qu’après démonstration
              d’une faute par le Client, d’un préjudice direct du Client (aucune prise en charge des dommages indirects)
              et d’un lien de causalité entre la faute et le préjudice susmentionnés. Le Fournisseur n’est plus tenu de
              la conservation des données du Client dès lors que ce dernier est désinscrit de l’Application. Il est de
              la responsabilité du Client de télécharger tous reçus utiles avant de se désinscrire de l’Application
              mobile. Toutefois, les reçus dématérialisés sont toujours accessibles, pendant leur durée légale de
              conservation, via le Site Internet Clean Bill, sur demande expresse du Client. En cas de défaillance ou
              négligence de sa part, le Client devra se rapprocher directement du Commerçant pour obtenir le double de
              ses Reçus. Le Client reste à tout moment propriétaire de ses Reçus.
            </p>

            <h3>Du fait de l’achat, fait générateur du reçu</h3>
            <p>
              Clean Bill est uniquement un Fournisseur de solution de stockage et de consultation de reçus. Clean Bill
              ne saurait voir sa responsabilité engagée du fait des achats effectués chez le Commerçant à l’origine de
              l’émission du reçu et plus généralement de toutes relations entre le Client et le Commerçant. Les
              garanties contractuelles des produits ou des prestations de services, les garanties des vices cachés ou de
              délivrance conforme incombent exclusivement aux Commerçants pour les produits ou services à l’origine de
              l’émission des Reçus.
            </p>

            <h3>Du fait des vices cachés</h3>
            <p>
              Il est rappelé que, conformément à l’article 1641 du Code civil, « le vendeur est tenu de la garantie à
              raison des défauts cachés de la chose vendue qui la rendent impropre à l'usage auquel on la destine, ou
              qui diminuent tellement cet usage que l'acheteur ne l'aurait pas acquise, ou n'en aurait donné qu'un
              moindre prix, s'il les avait connus ». Cette garantie est limitée au remplacement ou au remboursement des
              services non conformes ou affectés d’un vice. Toute garantie est exclue en cas de mauvaise utilisation,
              négligence, erreur de manipulation ou défaut d’entretien, de la part du Client, du mobile sur lequel
              l’application est téléchargée, ou encore en cas de force majeure ou de modification des configurations et
              paramètres. Afin de faire valoir ses droits, le Client devra, sous peine de déchéance de toute action s’y
              rapportant, informer le Fournisseur, par Lettre Recommandée avec Accusé de Réception, de l’existence des
              vices dans un maximum de DIX (10) jours à compter de leur découverte.
            </p>

            <h3>Du fait de l’apparence de l’Application</h3>
            <p>
              Les photographies et graphismes présentés sur les Solutions Clean Bill ne sont pas contractuels et ne
              sauraient engager la responsabilité de Clean Bill.
            </p>

            <h3>La garantie légale de conformité</h3>
            <p>
              Il est rappelé que l’article L217-4 du Code civil prévoit que « Le vendeur livre un bien conforme au
              contrat et répond des défauts de conformité existant lors de la délivrance. Il répond également des
              défauts de conformité résultant de l'emballage, des instructions de montage ou de l'installation lorsque
              celle-ci a été mise à sa charge par le contrat ou a été réalisée sous sa responsabilité ».
            </p>

            <h3>La force majeure</h3>
            <p>
              La force majeure est exonératoire de toute responsabilité au titre de la non-exécution totale ou partielle
              des présentes Conditions Générales d’Utilisation. Au sens des présentes Conditions Générales
              d’Utilisation, sont assimilés à la force majeure (liste non exhaustive) :
            </p>
            <ul>
              <li>Les pannes occasionnant des interruptions de service sur la ligne Internet du Fournisseur ou de
                l’hébergeur des données ou encore les coupures d’alimentation électrique du fait du distributeur ;
              </li>
              <li>Le séisme, l’incendie, les inondations, la tempête, la foudre ou autres aléas climatiques ou encore
                les détériorations ou la destruction partielle ou totale des installations de la plateforme technique de
                Clean Bill ;
              </li>
              <li>Les perturbations, dysfonctionnement ou interruptions momentanés de l’alimentation électrique de Clean
                Bill pour des raisons indépendantes de la volonté de cette dernière ;
              </li>
              <li>L’indisponibilité du serveur hébergé découlant d’une interruption totale ou partielle du service des
                lignes administrées par les opérateurs télécom et fournisseurs d’accès auxquels Clean Bill a recours.
              </li>
            </ul>
            <p>
              Clean Bill s’engage à entreprendre tout ce qui est en son pouvoir pour obtenir des exploitants
              responsables des perturbations, dysfonctionnement ou interruptions le rétablissement des services leur
              incombant. En cas de survenance d’un cas de force majeure au sens de la jurisprudence française, les
              obligations des Parties seront suspendues. De convention expresse, il est rappelé en sus de ce qui est
              indiqué ci- dessus que constitue notamment un cas de force majeure, l’indisponibilité des serveurs due aux
              perturbations des réseaux de télécommunication ainsi que toutes indisponibilités de la plateforme
              technique imputable à des causes étrangères à Clean Bill ou hors de son contrôle. Si la force majeure
              persiste au-delà d’une durée de QUINZE (15) jours, le recours aux services Clean Bill pourront être
              résiliés de plein droit par l’une ou l’autre des Parties par Lettre recommandée avec Accusé de réception.
            </p>

            <h2>ARTICLE 4 – PROPRIETE INTELLECTUELLE</h2>
            <p>
              Le contenu de l’Application est la propriété du Fournisseur et de ses partenaires et est protégé par les
              lois françaises et internationales relatives à la propriété intellectuelle. Les textes et les éléments
              graphiques, leur assemblage sur l’Application sont la propriété exclusive de Clean Bill et sont protégés
              au titre de la législation applicable en matière de droit d'auteur. Les logos, signes distinctifs du
              Fournisseur sont protégés au titre du droit des marques. Toute détérioration des éléments présents sur
              l’Application, en l'absence d'autorisation expresse, toute reproduction, téléchargement, copie,
              modification, utilisation commerciale, totale ou partielle, des différents éléments de l’Application (hors
              les Reçus) sont interdits et exposent son ou ses auteurs à des poursuites. Les Conditions Générales
              d’Utilisation n'autorisent en aucun cas la reproduction, la modification ou l'utilisation commerciale des
              différents éléments de l’Application (hors les Reçus). En accédant à l’Application, le Fournisseur vous
              accorde une licence d'utilisation aux conditions suivantes : un droit d'usage privé, personnel et non
              transmissible sur le contenu de l’Application ou l'un des éléments qui le composent, un droit de
              reproduction pour stockage. Toute utilisation de documents issus de l’Application doit mentionner sa
              source. Toute autre utilisation est interdite, notamment les utilisations à des fins commerciales, une
              utilisation en réseau, l'extraction répétée et systématique d'éléments de l’Application réalisés en
              contravention des dispositions de la Loi n°98-536 du 1er juillet 1998, concernant la protection juridique
              des bases de données. Toute utilisation de l’Application en contradiction avec les dispositions du présent
              article est constitutive d'un délit de contrefaçon, dont il pourra être demandé à la personne ayant commis
              un tel délit (« Contrefacteur »), d'en répondre. Des sanctions civiles et pénales peuvent être prononcées
              à l'encontre de tout Contrefacteur. En outre, le Fournisseur reste propriétaire de tous les droits de
              propriété intellectuelle sur les photographies, présentations, etc., réalisées (même à la demande du
              Client) en vue de la fourniture des Services au Client. Le Client s’interdit toute reproduction ou
              exploitation de ces éléments sans l’autorisation expresse, écrite et préalable du Fournisseur qui peut la
              conditionner à une contrepartie financière.
            </p>

            <h2>ARTICLE 5 – DONNEES PERSONNELLES</h2>
            <p>
              Conformément à la loi Informatique et Libertés du 6 janvier 1978, renforcée et complétée par le Règlement
              Général sur la Protection des Données (RGPD) entré en vigueur le 25 mai 2018, le Client dispose, à tout
              moment, d’un droit d’accès, de rectification, d’opposition, d’effacement et de portabilité de l’ensemble
              de ses données personnelles en écrivant, par courrier et en justifiant de son identité, au Fournisseur à
              l’adresse suivante : 39 b chemin de l’Usclade 30340 Saint Privas Des Vieux. Pour rappel, les informations
              signalées d'un astérisque dans le formulaire d'inscription permettant de créer un compte sur l’Application
              sont obligatoires. A défaut de réponse, le Fournisseur ne sera pas en mesure de traiter la demande
              d'inscription du Client. Les présentes Conditions Générales d’Utilisation renvoient expressément le Client
              à la Politique de confidentialité Clean Bill, accessible via l’Application et le Site Internet Clean Bill.
            </p>

            <h2>ARTICLE 6 – SECURISATION DES DONNEES ET COOKIES</h2>
            <p>
              Toutes les données relatives à l’Application (y compris le nom, l’adresse et le numéro de carte de crédit
              le cas échéant) sont cryptées par le biais du procédé SSL afin que les informations communiquées soient
              protégées lors de leur transmission au centre de traitement. L’Application est également conçue pour être
              particulièrement attentive aux besoins du Client et utilise les cookies dans le but d'améliorer le service
              personnalisé destiné au Client. Les systèmes d'enregistrement automatique de l’Application sont considérés
              comme valant preuve, de la nature, du contenu et de la date de l’enregistrement des Reçus. Si le
              Fournisseur pense que le Compte du Client a été utilisé sans son consentement, il peut également suspendre
              ou restreindre l'accès à ce Compte. Si le Fournisseur limite l'accès à ce Compte, il le notifiera et
              offrira l'opportunité au Client de demander la restauration de ses droits d'accès si cela est adapté.
            </p>

            <h2>ARTICLE 7 – RESILIATION ET CESSION</h2>
            <p>
              Clean Bill peut fermer le Compte du Client lorsqu’il le souhaite en adressant au Client un préavis de deux
              mois. Il peut également fermer le Compte à tout moment dans les cas suivants (cette liste n’étant pas
              exhaustive) :
            </p>
            <ul>
              <li>Le Client manque à ses obligations issues du présent Contrat et/ou le Fournisseur est en droit de
                fermer son Compte ;
              </li>
              <li>Le Client n'accède pas à son Compte pendant trois ans.</li>
            </ul>
            <p>
              Si Clean Bill décide de fermer le Compte du Client, il l’avisera le plus tôt possible et, lorsque cela
              sera possible, il en fournira les raisons. Lorsque le compte est fermé, Clean Bill peut supprimer toutes
              les données stockées rattachées au compte, suspendre, restreindre ou interdire l'accès ou l'utilisation de
              ses Services, des sites, des logiciels, des systèmes (y compris les réseaux et serveurs utilisés pour
              fournir les services) gérés par Clean Bill ou en son nom ou de tout ou partie des Services ou conserver
              les informations de Compte dans sa base de données afin de remplir ses obligations légales. Il est
              expressément convenu que, le cas échéant, le débiteur d’une obligation de payer aux termes de la
              prestation délivrée par le Fournisseur, sera valablement mis en demeure par la seule exigibilité de
              l’obligation, conformément aux dispositions de l’article 1344 du Code civil. En tout état de cause, la
              Partie lésée pourra demander en justice l’octroi de dommages et intérêts. La résiliation pour force
              majeure ne pourra, nonobstant les conditions précédemment décrites de la force majeure, avoir lieu que
              QUINZE (15) jours après l’envoi d’une mise en demeure notifiée par Lettre Recommandée avec Accusé de
              Réception. Toutefois, cette mise en demeure devra mentionner l’intention d’appliquer le présent article.
            </p>

            <h3>Cession</h3>
            <p>
              Le Client ne peut céder aucun droit ni aucune obligation dans le cadre du présent Contrat sans le
              consentement écrit préalable de Clean Bill. Il n’est pas autorisé à transférer son Compte à un tiers.
              Clean Bill se réserve le droit de céder le présent Contrat ou tout droit ou obligation dans le cadre du
              présent Contrat à tout moment sans le consentement du Client. Cela n'affecte aucunement le droit du Client
              de fermer son Compte.
            </p>

            <h2>ARTICLE 8 – DROIT APPLICABLE – LANGUE – ILLEGALITE D’UNE CLAUSE</h2>
            <p>
              Les présentes Conditions Générales d’Utilisation sont régies et soumises au droit français. Elles sont
              rédigées en langue française. Dans le cas où elles seraient traduites en une ou plusieurs langues, seul le
              texte français ferait foi en cas de litige. Le fait qu’une disposition du présent contrat se révèle être,
              en totalité ou en partie, illicite ou inapplicable pour quelque raison que ce soit, sera sans incidence
              sur la validité des autres clauses des présentes conditions d’utilisation.
            </p>

            <h2>ARTICLE 9 – JURIDICTIONS COMPETENTES</h2>
            <p>
              Tous les litiges auxquels les présentes Conditions Générales d’Utilisation et les accords qui en découlent
              pourraient donner lieu, concernant tant leur validité, leur interprétation, leur exécution, leur
              résolution, leurs conséquences et leurs suites seront soumis aux tribunaux compétents dans les conditions
              de droit commun. L'absence d'action de la part de Clean Bill s'agissant d'un manquement, qu'il soit du
              fait du Client ou de celui d'autres personnes, ne saurait constituer une renonciation au droit d'agir de
              Clean Bill s'agissant de manquements similaires ou ultérieurs.
            </p>

            <h2>ARTICLE 10 – CONTACT</h2>
            <p>
              Le fournisseur est joignable par courrier postal au 39 B chemin de l’Usclade 30340 SAINT-PRIVAS-DES- VIEUX
              et par eMail à l’adresse contact@cleanbill.fr.
            </p>

          </Container>
        </div>
        <Footer/>
      </>
    );
  }
}

export default CGU;
